import React, { forwardRef, useImperativeHandle, useRef } from "react"
import styled from "styled-components"
import BothMaps from "@/components/Maps/BothMaps"
import GridContainer from "@/components/common/GridContainer"
import Text from "@/components/common/Text"
import { getCssSizeValue, getHtmlFromRedactorField } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import Sections from "@/components/BranchNavigator/Sections"
import Units from "@/components/BranchNavigator/Units"
import DownloadFiles from "@/components/BranchNavigator/downloadFiles/DownloadFiles"
import { useNavigatorContext } from "@/components/BranchNavigator"
import BranchSwitcher from "@/components/BranchNavigator/Mobile/BranchSwitcher"

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: calc(-1 * var(--paddingX)) !important;
	margin-right: 0;
	width: calc(100% + var(--paddingX) * 2);

	.padding-mobile {
		padding: var(--paddingX);
	}
`

const MapContainer = styled(GridContainer)`
	background-color: ${({ theme }) => theme.colors.platinum};
	padding: ${getCssSizeValue(36, BREAKPOINTS.MOBILE)};
	row-gap: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};
	z-index: 6;
`

const Navigator = forwardRef(function Navigator({ data }, fref) {
	const WrapperRef = useRef()
	const mapDescription = data?.mapDescription || ""
	const description = getHtmlFromRedactorField(mapDescription)
	const { isTextileCollection } = useNavigatorContext()

	useImperativeHandle(fref, () => WrapperRef.current, [])

	return (
		<Wrapper ref={WrapperRef} className={`col-mobile-8 col-desktop-16 padding`}>
			<MapContainer className="no-margin padding">
				<Text tag="div" dangerouslySetInnerHTML={description} className="desc col-mobile-8 typo-strawford typo-strawford-65" />
				<BothMaps className="col-mobile-8" />
			</MapContainer>
			<BranchSwitcher />
			<Sections data={data} className="padding-mobile" branchName />
			{!isTextileCollection ? <Units className={`col-mobile-8`} /> : <DownloadFiles className={`col-mobile-8 padding-mobile`} />}
		</Wrapper>
	)
})

export default Navigator
